interface IProps {
  onClick?: () => void;
  type?: 'button' | 'submit'
  className?: string;
  disabled?: boolean;
  children: JSX.Element | JSX.Element[] | string;
}

const Button = ({ onClick, children, className, disabled, type = 'button' }: IProps) => {
  return (
    <button type={type} className={className} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
